import { createServerFn } from "@tanstack/react-start";

export const fetchSubscriberCount = createServerFn({ method: "GET" }).handler(
  async (): Promise<number | null> => {
    try {
      const { supabaseAdmin } = await import(
        "@/integrations/supabase/client.server"
      );
      const { data, error } = await supabaseAdmin.rpc(
        "confirmed_subscriber_count",
      );
      if (error) return null;
      const n = typeof data === "number" ? data : Number(data);
      return Number.isFinite(n) ? n : null;
    } catch {
      return null;
    }
  },
);
